import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';
import ArticleBodySection from './article/components/ArticleBodySection';
import ArticleHeaderSection from './article/components/ArticleHeaderSection';
import { useArticleContent } from './article/hooks/useArticleContent';
import { useArticleMath } from './article/hooks/useArticleMath';
import { useArticleMetadata } from './article/hooks/useArticleMetadata';
import { useArticleSeo } from './article/hooks/useArticleSeo';

const Article = () => {
  const { slug } = useParams();
  const contentRef = useRef(null);

  const { status, articleHtml, frontmatter, readingTime } = useArticleContent(slug);
  const articleMetadata = useArticleMetadata({
    frontmatter,
    readingTime,
    slug,
    status,
  });

  useArticleSeo(articleMetadata);
  useArticleMath({
    articleHtml,
    contentRef,
    status,
  });

  return (
    <>
      <ArticleHeaderSection
        author={articleMetadata.author}
        dateLabel={articleMetadata.dateLabel}
        minutes={articleMetadata.minutes}
        publishedAt={articleMetadata.publishedAt}
        summary={articleMetadata.summary}
        tags={articleMetadata.tags}
        title={articleMetadata.title}
      />

      <ArticleBodySection articleHtml={articleHtml} contentRef={contentRef} status={status} />
    </>
  );
};

export default Article;
